import { widgetStore } from '../stores';

export const POST_MESSAGE_KEYS = {
  RESIZE_WIDGET: 'yacht:resize-widget',
  REDIRECT: 'yacht:redirect',
  INITIALIZED: 'yacht:initialized',
  ANALYTICS_CALENDAR_RENDER: 'yacht:analytics:calendar-render',
  ANALYTICS_PRICE_CHECK: 'yacht:analytics:price-check',
  ANALYTICS_SEND_QUESTION: 'yacht:analytics:send-question',
  ANALYTICS_BOOKING_CREATE: 'yacht:analytics:booking-create',
  ANALYTICS_COMMERCE_VIEW_ITEM: 'yacht:analytics-commerce:view-item',
  ANALYTICS_COMMERCE_GENERATE_LEAD: 'yacht:analytics-commerce:generate-lead',
  ANALYTICS_COMMERCE_PURCHASE: 'yacht:analytics-commerce:purchase',
};

export const sendData = payload => {
  try {
    const { parent } = window;
    parent.postMessage(JSON.stringify(payload), '*');
  } catch (error) {
    console.warn(error); // eslint-disable-line
  }
};

export const sendAnalyticsData = payload => {
  try {
    if (widgetStore.analyticsEnabled) {
      setTimeout(() => {
        const { parent } = window;
        // eslint-disable-next-line no-console
        // console.log(`@@@ Client GA event: ${payload.action}`, { ...payload });
        parent.postMessage(JSON.stringify(payload), '*');
      }, 500); // wait for 500ms to ensure the message is sent
    }
  } catch (error) {
    console.warn(error); // eslint-disable-line
  }
};

export const iSJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
